import { AppCustomerNetworkRiskScoreSettingsResultCategory } from '@nk/data-entities-lib';

export function resolveNetworkRiskResultCategory(
  score: number,
  ranges: AppCustomerNetworkRiskScoreSettingsResultCategory[],
): AppCustomerNetworkRiskScoreSettingsResultCategory {
  const result = ranges.find((range) => {
    const to = range.score_range_to || 9999999999999;
    const from = range.score_range_from || 0;
    return score >= from && score < to;
  });
  if (!result) {
    throw Error(
      `Could not find category. Score: ${score} Ranges: ${ranges
        .map((a) => a.score_range_from + '- ' + a.score_range_to)
        .join(',')}`,
    );
  }
  return result;
}
